import { createReducer, on } from '@ngrx/store';

import { BreadcrumbItem } from 'ish-core/models/breadcrumb-item/breadcrumb-item.interface';

import {
  setBreadcrumbData,
  setHeaderHeight,
  setIsTransparentHeader,
  setSearchBoxActive,
  setStickyHeader,
} from './viewconf.actions';

export interface ViewconfState {
  breadcrumbData: BreadcrumbItem[];
  stickyHeader: boolean;
  /* Dias customization start */
  headerHeight: number;
  searchBoxActive: boolean;
  isTransparentHeader?: boolean;
  /* Dias customization end */
}

export const initialState: ViewconfState = {
  breadcrumbData: [],
  stickyHeader: false,
  headerHeight: 0,
  searchBoxActive: false,
  isTransparentHeader: false,
};

export const viewconfReducer = createReducer(
  initialState,
  on(
    setBreadcrumbData,
    (state, action): ViewconfState => ({
      ...state,
      breadcrumbData: action.payload.breadcrumbData,
    })
  ),
  on(
    setStickyHeader,
    (state, action): ViewconfState => ({
      ...state,
      stickyHeader: action.payload.sticky,
    })
  ),
  on(
    setHeaderHeight,
    (state, action): ViewconfState => ({
      ...state,
      headerHeight: action.payload.headerHeight,
    })
  ),
  on(
    setSearchBoxActive,
    (state, action): ViewconfState => ({
      ...state,
      searchBoxActive: action.payload.searchBoxActive,
    })
  ),
  on(
    setIsTransparentHeader,
    (state, action): ViewconfState => ({
      ...state,
      isTransparentHeader: action.payload.isTransparentHeader,
    })
  )
);
